    import { useMemo, useRef, useState } from "react";
    import { ColDef, ColumnState } from "ag-grid-community";
    import { AgGridReact } from "ag-grid-react";
    import { GridContextWrapper } from "src/components/common/gridWrapper/GridContextWrapper";
    import Grid_Select from "src/components/common/gridWrapper/Grid_Select";
    import { PDA1130_R01ItemDto } from "./PDA1130_R01Dto";
    import usePDA1130_R01Store from "./usePDA1130_R01Store";
    import { aggridHeaderClass, pdaCellStyle } from "src/components/common/common";

    /** 출고 목록 행: 품목 + 지시량/검수량/잔량(계산) */
    type OutboundRow = PDA1130_R01ItemDto & {
    currentInspQty: number;
    remainQty: number;
    inserted?: boolean;
    };

    const PDA1130_R01DetailTable = () => {
    const { shippingDetail, inspectedItems } = usePDA1130_R01Store();
    const gridRef = useRef<AgGridReact<OutboundRow>>(null);
    const gridWrapperRef = useRef<HTMLDivElement>(null);
    const [hoveredRowIndex, setHoveredRowIndex] = useState<number | null>(null);
    const [columnState, setColumnState] = useState<ColumnState[] | null>(null);

    const itemList = shippingDetail?.itemList ?? [];
    const paddedGridData = useMemo<OutboundRow[]>(() => {
        return itemList.map((item) => {
        const pendingQty = inspectedItems
            .filter((i) => i.itemCd === item.itemCd)
            .reduce((sum, i) => sum + i.shipQty, 0);
        const currentInspQty = item.inspQty + pendingQty;
        const remainQty = Math.max(0, item.orderQty - currentInspQty);
        return {
            ...item,
            currentInspQty,
            remainQty,
        };
        });
    }, [itemList, inspectedItems]);

    const columnDefs: ColDef<OutboundRow>[] = useMemo(
        () => [
        // {
        //     headerName: "품목코드",
        //     field: "itemCd",
        //     valueGetter: (params) => params.data?.itemCd ?? "-",
        //     cellStyle: () => ({ textAlign: "left", ...pdaCellStyle }),
        //     headerClass: aggridHeaderClass,
        //     flex: 1.2,
        //     minWidth: 80,
        // },
        {
            headerName: "품명",
            field: "itemNm",
            valueGetter: (params) => params.data?.itemNm ?? "-",
            cellStyle: () => ({ textAlign: "left", ...pdaCellStyle }),
            headerClass: aggridHeaderClass,
            flex: 2,
            minWidth: 80,
        },
        {
            headerName: "주문잔량",
            field: "orderQty",
            valueGetter: (params) =>
            params.data?.orderQty != null ? params.data.orderQty.toLocaleString() : "-",
            cellStyle: () => ({
            textAlign: "right",
            justifyContent: "flex-end",
            ...pdaCellStyle,
            }),
            headerClass: aggridHeaderClass,
            flex: 0.9,
            minWidth: 80,
        },
        {
            headerName: "검수량",
            field: "currentInspQty",
            valueGetter: (params) =>
            params.data?.currentInspQty != null
                ? params.data.currentInspQty.toLocaleString()
                : "-",
            cellStyle: (params) => ({
            textAlign: "right",
            justifyContent: "flex-end",
            fontWeight: params.data?.currentInspQty ? "bold" : "normal",
            color: params.data?.currentInspQty ? "#f57c00" : "#999",
            backgroundColor: params.data?.currentInspQty ? "#fff9c4" : "white",
            ...pdaCellStyle,
            }),
            headerClass: aggridHeaderClass,
            flex: 0.9,
            minWidth: 80,
        },
        
        {
            headerName: "단위",
            field: "unit",
            valueGetter: (params) => params.data?.unit ?? "-",
            cellStyle: () => ({ textAlign: "center", ...pdaCellStyle }),
            headerClass: aggridHeaderClass,
            flex: 0.5,
            minWidth: 80,
        },
        ],
        []
    );

    const initSelected = () => {};

    return (
        <div className="flex-1 p-3 pt-0 flex w-full h-full flex-col overflow-hidden">
        {!shippingDetail ? (
            <div className="flex-1 flex items-center justify-center">
            <div className="text-center text-gray-500">
                <p className="text-lg mb-2">📋</p>
                <p>출하지시를 선택하면</p>
                <p>출고 목록이 표시됩니다</p>
            </div>
            </div>
        ) : itemList.length === 0 ? (
            <div className="flex-1 flex items-center justify-center">
            <div className="text-center text-gray-500">
                <p className="text-lg mb-2">📋</p>
                <p>출고할 품목이 없습니다</p>
            </div>
            </div>
        ) : (
            <GridContextWrapper
            gridRef={gridRef}
            gridWrapperRef={gridWrapperRef}
            paddedGridData={paddedGridData}
            initSelected={initSelected}
            baseColumnDefs={columnDefs}
            setColumnState={setColumnState}
            localStorageKey="PDA1130_R01_OutboundTable_ColumnState"
            enableDataHistory={false}
            >
            <div className="flex-1 w-full h-full min-h-0">
                <Grid_Select<OutboundRow>
                ref={gridRef}
                rowData={paddedGridData}
                columnDefs={columnDefs}
                setHoveredRowIndex={setHoveredRowIndex}
                columnStateKey="PDA1130_R01_OutboundTable_ColumnState"
                setColumnState={setColumnState}
                />
            </div>
            </GridContextWrapper>
        )}
        {shippingDetail && itemList.length > 0 && (
            <div className="px-2 py-2 border-t border-gray-200 bg-white">
            <p className="text-sm text-gray-500 text-center">
                출고 목록 ·  LOT 스캔 후 검수하면 검수량이 반영됩니다
            </p>
            </div>
        )}
        </div>
    );
    };

    export default PDA1130_R01DetailTable;
